export default __webpack_public_path__ + "static/premio_exlclusivo-PE-e8250795c8cc6302deb3318993cf6363.png";